import type { Route } from 'types';

import Sessions from './Sessions';

const routes: Route[] = [
  { name: 'Sessions', path: '/sessions', component: Sessions },
];

export default routes;
